import requst from './req'
// 废弃
// 获取用户信息
export function getUserInfo() {
  return sessionStorage.getItem('userinfo') || null
}
// 废弃
// 设置用户信息
export function setUserInfo(info) {
  sessionStorage.setItem('userinfo', JSON.stringify(info))
}
// // 判断用户是否购买了商品
export function goodsauthtwo(id) {
  return requst.get(
    '//service.agent.pro.caixuetang.cn?site=pay&c=order&a=getobjectidbymember&v=user',
    {
      params: {
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        object_id: '1309',
        appcode: sessionStorage.getItem('appCode')
      }
    }
  )
}
/**
 * 通过比例计算实际宽高
 * @param {number} devBase 编写时的基础宽高
 * @param {number} nowBase 实际基础宽高
 */
export const computePX = function (devBase, nowBase) {
  var ratio = nowBase / devBase
  return function (devPx) {
    return ratio * devPx
  }
}

/**
 * 获取Url
 * @param {string} url 就是url
 * @param {string} name 你要获取的query的名字
 */

export const getUrl = function (url, name) {
  if(url === undefined || url === '') return
  if(name === undefined || name === '') return
  if(!url.split('?')[1]) return
  url = url.split('?')[1]
  url = url.split('&')
  let obj = {}
  url.map((val) => {
    let url = val.split('=')
    obj[url[0]] = url[1]
  })
  return obj[name]
}
export function iswx(){
	var ua = navigator.userAgent.toLowerCase();
	if(/MicroMessenger/i.test(ua)) {
		return true;
 	} else {
		return false;
	}
}
export function iszfb(){
	var ua = navigator.userAgent.toLowerCase();
	if(/AlipayClient/i.test(ua)) {
		return true;
 	} else {
		return false;
	}
}
